module.exports = __webpack_public_path__ + "static/media/aadi_event.c8e2cc03.jpg";